<p-dialog
    header="{{ 'home.widgetConnect.widgetConnectModal.searchContact' | translate }}"
    [(visible)]="visible"
    (onHide)="closeModal()"
    [modal]="true"
    [style]="{ width: '75vw', maxWidth: '640px', height: '90vh' }"
    [responsive]="true"
    [breakpoints]="{ '641px': '100vw' }"
    [contentStyle]="{ 'overflow-y': 'auto', padding: '1rem' }"
    [baseZIndex]="10000"
>
    <p-tabView>
        <p-tabPanel header="{{ 'home.widgetConnect.widgetConnectModal.skills' | translate }}">
            <app-widget-connect-filters
                radioButtonGroupName="skillGroup"
                [radioLabelMine]="'home.widgetConnect.widgetConnectModal.filtersSkills.radioLabelMine' | translate"
                [radioLabelSpecific]="'home.widgetConnect.widgetConnectModal.filtersSkills.radioLabelSpecific' | translate"
                [dropdownPlaceholder]="'home.widgetConnect.widgetConnectModal.filtersSkills.dropdownPlaceholder' | translate"
                [dropdownOptions]="skills"
            >
            </app-widget-connect-filters>
        </p-tabPanel>

        <p-tabPanel header="{{ 'home.widgetConnect.widgetConnectModal.interests' | translate }}">
            <app-widget-connect-filters
                radioButtonGroupName="interestGroup"
                [radioLabelMine]="'home.widgetConnect.widgetConnectModal.filtersInterests.radioLabelMine' | translate"
                [radioLabelSpecific]="'home.widgetConnect.widgetConnectModal.filtersInterests.radioLabelSpecific' | translate"
                [dropdownPlaceholder]="'home.widgetConnect.widgetConnectModal.filtersInterests.dropdownPlaceholder' | translate"
                [dropdownOptions]="interests"
            >
            </app-widget-connect-filters>
        </p-tabPanel>
    </p-tabView>
    <div class="field p-d-flex p-ai-center p-mb-3 md:ml-4">
        <label for="community" class="p-mr-3 p-ml-3 label-fixed-width">{{ 'home.widgetConnect.widgetConnectModal.within' | translate }}</label>
        <p-dropdown
            [options]="user?.communities"
            optionLabel="name"
            [(ngModel)]="selectedCommunity"
            placeholder="{{ 'home.widgetConnect.widgetConnectModal.myCommunities' | translate }}"
            [showClear]="true"
            styleClass="p-flex-grow-1"
        >
        </p-dropdown>
    </div>
    <ng-template pTemplate="footer">
        <div class="p-d-flex p-jc-between p-ai-center">
            <p-button
                label="{{ 'home.widgetConnect.widgetConnectModal.reset' | translate }}"
                icon="pi pi-refresh"
                styleClass="p-button-outlined"
                (click)="reset()"
            ></p-button>

            <div>
                <p-button
                    label="{{ 'home.widgetConnect.widgetConnectModal.cancel' | translate }}"
                    styleClass="p-button-text p-mr-2"
                    (click)="closeModal()"
                ></p-button>
                <p-button label="{{ 'home.widgetConnect.widgetConnectModal.search' | translate }}" (click)="search()"></p-button>
            </div>
        </div>
    </ng-template>
</p-dialog>
